var cov_2e7v2hkub1 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/validate/nullable.ts",
      hash = "d957d7a99765e890d938e616589bd445b007e94b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/validate/nullable.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 9,
          column: 3
        }
      },
      "2": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 18
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 10
        }
      },
      "4": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 53
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 1,
            column: 53
          },
          end: {
            line: 1,
            column: 54
          }
        },
        loc: {
          start: {
            line: 5,
            column: 5
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 6,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 6,
            column: 19
          }
        }, {
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 41
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default (function (fn) {
  cov_2e7v2hkub1.f[0]++;
  cov_2e7v2hkub1.s[0]++;
  return function (value, formdata, callback) {
    cov_2e7v2hkub1.f[1]++;
    cov_2e7v2hkub1.s[1]++;

    if ((cov_2e7v2hkub1.b[1][0]++, value == null) || (cov_2e7v2hkub1.b[1][1]++, value.length === 0)) {
      cov_2e7v2hkub1.b[0][0]++;
      cov_2e7v2hkub1.s[2]++;
      callback(true);
      cov_2e7v2hkub1.s[3]++;
      return;
    } else {
      cov_2e7v2hkub1.b[0][1]++;
    }

    cov_2e7v2hkub1.s[4]++;
    fn(value, formdata, callback);
  };
});